import BlogsContent from "@/components/Blog/BlogsContent";
import CustomLink from "@/components/Buttons/CustomLink";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";

export default function BlogArticleSwiper({ blogs, color }) {
  const locale = useLocale();

  return (
    <div className="container flex flex-col pt-10 sm:pt-20 md:pt-[117px]">
      <div className="flex justify-between items-center relative z-20">
        <h2 className="max-w-[800px] text-white-green text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-purple font-normal">
          Enjoy more articles
        </h2>
        <CustomLink
          href={localizePath("/newsroom", locale)}
          color="purple"
          styles="text-sm font-medium md:text-xl"
        >
          View all blogs
        </CustomLink>
      </div>
      <div className="sm:-mt-20">
        <BlogsContent
          blogData={blogs}
          color={color}
          style={{
            arrow: "[&>path]:fill-white [&>path]:stroke-white",
            txt: "text-[#1b0d34]",
          }}
        />
      </div>
    </div>
  );
}
